import { template } from 'lodash';
import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';
import sampleTemplate from './sample';

const initialState = [];


export default function appReducer(state = initialState, action) {
    switch (action.type) {

        case types.ADD_TEMPLATED_CLUSERLET: {
            return [
                ...state,
                action.payload
            ]
        }

        case types.EDIT_TEMPLATE: {
            return [...state.map(template => template?.id == action?.payload?.id ? (action.payload) : ({ ...template }))]
        }

        case types.UPDATE_FULL_TEMPLATE: {
            return [
                ...state,
                ...action.payload
            ]
        }

        case types.RESET_TEMPLATE: {
            return [
                // ...state,
                ...action.payload
            ]
        }

        case types.DELETE_TEMPLATE: {
            return state.filter(template => template.id !== action.payload.id)
        }

        case 'RESET_BLUEPRINT':
            return cloneDeep(initialState);


        default:
            return state;
    }


}